import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css'; 

function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div className="home-wrapper bg-surface min-h-screen">
      <header className="modern-header">
        <div className="container header-flex">
          <div className="brand-box flex-center cursor-pointer" onClick={() => navigate('/')}>
            <img src="/logo.png" alt="Logo" className="nav-logo" onError={(e) => e.target.style.display='none'} />
            
          </div>
          <button className="btn-action-outline" onClick={() => navigate('/')}>← Back to Home</button>
        </div>
      </header>

      <main className="section-padding">
        <div className="container">
          <div className="card-editorial border-left-highlight" style={{ maxWidth: '900px', margin: '0 auto', borderLeftColor: '#4f64d8' }}>
            <h1 className="section-title-large mb-8">Privacy Policy</h1>
            <p className="text-subtitle mb-8">Last Updated: April 2026</p>

            <div className="prose" style={{ lineHeight: '1.8', color: '#444653' }}>
              <h3 className="section-title mb-4">1. Information We Collect</h3>
              <p className="mb-6">
                The Bathinda Housing Complex Co-operative House Building Society Ltd. collects information essential for community management and procurement. This includes personal contact details (names, phone numbers, email addresses, plot/house numbers) for society members, and business documentation for vendors participating in our tendering system.
              </p>

              <h3 className="section-title mb-4">2. How We Use Your Information</h3>
              <ul className="mb-6" style={{ paddingLeft: '20px' }}>
                <li className="mb-2"><strong>Community Management:</strong> To maintain an accurate register of members, track dues, and communicate important announcements[cite: 224, 241].</li>
                <li className="mb-2"><strong>Tender Processing:</strong> To evaluate vendor applications, verify credentials, and communicate regarding active bids.</li>
                <li className="mb-2"><strong>Financial Operations:</strong> To accurately log payments for monthly charges, annual fees, and fines against the correct member accounts.</li>
              </ul>

              <h3 className="section-title mb-4">3. Payment Security</h3>
              <p className="mb-6">
                All digital transactions are securely processed via Razorpay. The Society does not collect, store, or have direct access to your credit card numbers, UPI PINs, or raw banking passwords. We only store the transaction reference IDs and payment statuses to update our internal ledgers.
              </p>

              <h3 className="section-title mb-4">4. Public Transparency & Data Sharing</h3>
              <p className="mb-6">
                Because we operate a transparent digital procurement system, certain data submitted by vendors—such as business names and quoted bid amounts—will be published in the public domain as part of our tender results. Personal member data is kept strictly confidential and is only accessed by the Managing Committee and authorized administrative staff to carry out the business of the Society[cite: 246].
              </p>

              <h3 className="section-title mb-4">5. Contact Us</h3>
              <p className="mb-2">If you have any questions or concerns about how your data is handled, please reach out to us:</p>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                <li>📱 <strong>Mobile & WhatsApp:</strong> +91 9872348700</li>
                <li>✉️ <strong>Email:</strong> bhcchbs@gmail.com</li>
                <li>📍 <strong>Address:</strong> Housefed Colony, Bathinda, Punjab, India 151001</li>
              </ul>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default PrivacyPolicy;